import React, { useState, useEffect, useRef } from 'react'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TablePagination from '@mui/material/TablePagination'
import TableSortLabel from '@mui/material/TableSortLabel'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import {
  TableFooter,
  TableRow,
  Paper,
  TableHead,
  TableContainer,
  TableBody,
  Table,
  Box,
  CircularProgress,
  TextField,
  Modal,
  Button, Checkbox,
  useMediaQuery,
} from '@mui/material'
import { mainApi } from '../../store/services/mainApi'
import { useNavigate } from 'react-router'
import lock from '../../assets/svg/BoxIcons/lockIcon.svg'
import { useDispatch } from 'react-redux'
import ProductManagerFilter from './ProductManagerFilter/ProductManagerFilter'
import { ProductManagerTableMobileRow } from './ProductManagerTableItems/ProductManagerTableMobileRow'
import { ProductManagerTableRow } from './ProductManagerTableItems/ProductManagerTableRow'
import AlphaSortBar from './AlphaSortBar/AlphaSortBar';
import AddToStockModal from './AddToStockModal/AddToStockModal'
import AddToStockHistoryModal from "./AddToStockHistoryModal/AddToStockHistoryModal";




export default function ProductsManager() {
  const [rows, setRows] = useState([])

  const { data, isLoading, refetch: refetchAll } = mainApi.useFindAllWordsQuery()
  const { data: itemsProcessing, isLoading2 } = mainApi.useGetItemsProcessingAdminQuery()
// console.log(itemsProcessing)
  const [updateProductsManager] = mainApi.useUpdateProductsManagerMutation()
  const dispatch = useDispatch()

  useEffect(() => {
    if (data) {
      console.log(data)
      setRows(data)
    }
  }, [data])

  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('name')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(50)
  const [search, setSearch] = useState('')
  const [ isFilterLessZeroStock, setIsFilterLessZeroStock ] = useState(false)
  const [ isFilterLessZeroProcessing, setIsFilterLessZeroProcessing ] = useState(false)

  // console.log(
  //   page
  // );



  const handleRequestSort = (event, property) => {
    const isAscending = orderBy === property && order === 'asc'
    setOrder(isAscending ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value))
    setPage(0)
  }

  const handleSearchChange = (event) => {
    event.stopPropagation()
    setSearch(event.target.value) // Updating search state
  }



  const stateFields = [
    "marketPriceCP",
    "ourPrice",
    "totalQuantity",
    "stock",
    // "reserve",
    "place",
    "stand",
    "shelf"
  ];
  const stateSetters = {
    marketPriceCP: useState({}),
    ourPrice: useState({}),
    totalQuantity: useState({}),
    stock: useState({}),
    reserve: useState({}),
    place: useState({}),
    stand: useState({}),
    shelf: useState({}),
  };

  const [openRows, setOpenRows] = useState({});
  const inputRefs = useRef({});

  useEffect(() => {
    stateFields.forEach((field) => {
      Object.keys(stateSetters[field][0]).forEach((key) => {
        const inputRef = inputRefs.current[key];
        if (inputRef) {
          //inputRef.focus();
        }
      });
    });
  }, [...stateFields.map(field => stateSetters[field][0])]);

  // useEffect(() => {
  //   console.log(stateSetters)
  // }, [stateSetters])

  const handleChange = (field, value, event, sku) => {
    // console.log(event);
    event.stopPropagation();
    event.preventDefault();
    stateSetters[field][1]((prev) => ({ ...prev, [sku]: value }));
  };


  const toggleRowOpen = (rowId) => {
    setOpenRows((prev) => ({ ...prev, [rowId]: !prev[rowId] }));
  };

  const saveSpoPrice = async (row) => {
    console.log(row);
    const changesForRow = {};

    stateFields.forEach((field) => {
      Object.entries(stateSetters[field][0])
        .filter(([key]) => key.includes(row.sku))
        .forEach(([key, value]) => {
          changesForRow[field] = value;
        });
    });

    if (Object.keys(changesForRow).length === 0) return;
    console.log(changesForRow);
    try {
      const user = JSON.parse(localStorage.getItem('acc'));
      const currentDate = new Date().toLocaleDateString('en-GB'); // Формат DD.MM.YYYY

      await Promise.all(
        Object.entries(changesForRow).map(([key, value]) =>
          console.log(`Updating ${key}:`, value, row.sku),
          updateProductsManager({
            sku: row.sku,
            ...changesForRow,
            updatedBy: user.name,
            updatedAt: currentDate,
          }).unwrap()
        ),
      );

      alert('Product updated successfully!');
      dispatch(mainApi.util.invalidateTags(['PersonalSalesList']));
    } catch (error) {
      console.error('Failed to update product:', error);
      alert('Failed to update product');
    }
  };


  // eslint-disable-next-line react/display-name
  ProductManagerTableRow.propTypes = {
    row: PropTypes.shape({
      name: PropTypes.string.isRequired,
      sku: PropTypes.string.isRequired,
      marketPrice: PropTypes.number.isRequired,
      ourPrice: PropTypes.number.isRequired,
      totalQuantity: PropTypes.number.isRequired,
      stock: PropTypes.number.isRequired,
      reserve: PropTypes.number.isRequired,
      place: PropTypes.number.isRequired,
      shelft: PropTypes.number.isRequired,
      stand: PropTypes.number.isRequired,

      // clients: PropTypes.arrayOf(
      //   PropTypes.shape({
      //     client_id: PropTypes.string.isRequired,
      //     client_name: PropTypes.string.isRequired,
      //     ourPrice: PropTypes.number.isRequired,
      //     quantity: PropTypes.number.isRequired,
      //   }),
      // ).isRequired,
    }).isRequired,
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'rgba(23, 99, 24, 0.9019607843)',
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }))


  const [filters, setFilters] = useState({
    place: 'All',
    shelf: 'All',
    stand: 'All',
    stock: 'All',
    refetch: false
  })
  const [filteredRowsLength, setFilteredRowsLength] = useState(0)

  const [paginatedRows, setPaginatedRows] = useState([])
  const [paginatedRowsValues, setPaginatedRowsValues] = useState([])
  const [categorySortDerection, setCategorySortDerection] = useState({
    name: 0,
    value: 0,
  })

  const handleSort = (key) => {
    // Toggle between ascending, descending, and null (no sorting)
    if (categorySortDerection === null || typeof categorySortDerection.value === 'undefined') {
      throw new Error('categorySortDerection is null or undefined')
    }
    if (typeof key === 'undefined') {
      throw new Error('key is undefined')
    }
    if (categorySortDerection.value === -1 && categorySortDerection.name === key) {
      setCategorySortDerection({ name: key, value: 0 })
    } else if (categorySortDerection.value === 1 && categorySortDerection.name === key) {
      setCategorySortDerection({ name: key, value: -1 }) // Descending order
    } else {
      setCategorySortDerection({ name: key, value: 1 }) // No sorting
    }
  }
  function parseDate(dateStr) {
    if (!dateStr) {
      return null;
    }
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day); // месяц в JS начинается с 0
  }
  const [letters, setLetters] = useState([])
  const [activeLetter, setActiveLetter] = useState(null)

  function normalizeToEnglish(str) {
    // Карта замены русских букв на английские
    const ruToEnMap = {
      'А': 'A', 'В': 'B', 'С': 'C', 'Е': 'E', 'Н': 'H',
      'К': 'K', 'М': 'M', 'О': 'O', 'Р': 'P', 'Т': 'T',
      'Х': 'X', 'а': 'a', 'в': 'b', 'с': 'c', 'е': 'e',
      'н': 'h', 'к': 'k', 'м': 'm', 'о': 'o', 'р': 'p',
      'т': 't', 'х': 'x'
    };

    return str
      .normalize('NFD') // Разложение символов на базовые и диакритические
      .replace(/[\u0300-\u036f]/g, '') // Удаление диакритических знаков
      .split('')
      .map(char => ruToEnMap[char] || char) // Замена русских букв
      .join('');
  }

  useEffect(() => {
    const searchLower = search.toLowerCase()

    const filteredRows = rows?.filter((row) => {
      try {
        return normalizeToEnglish(row.name?.toString())?.toLowerCase().includes(normalizeToEnglish(searchLower))
        || row.sku?.toString()?.toLowerCase().includes(searchLower)
        || row.nameProveedor?.toString()?.toLowerCase().includes(searchLower)
      }catch (e) {
        console.log(row.name, row.sku)
      }
      // Return true if any of the conditions match
    })
    setLetters([...new Set([...filteredRows].map((row) => normalizeToEnglish(row.name.charAt(0))))]?.sort((a, b) => a.localeCompare(b)))

  }, [rows, filters, search, itemsProcessing,  isFilterLessZeroStock])

  useEffect(() => {
    // Filter the rows based on the search query
    // console.log(rows);
    const searchLower = search.toLowerCase()

    const filteredRows = rows?.filter((row) => {
      // console.log(row.nameProveedor+' '+(row.nameProveedor ? toString(row.nameProveedor)?.toLowerCase().includes(searchLower) : true));
      try {
        return normalizeToEnglish(row.name?.toString())?.toLowerCase().includes(normalizeToEnglish(searchLower))
        || row.sku?.toString()?.toLowerCase().includes(searchLower)
        || row.nameProveedor?.toString()?.toLowerCase().includes(searchLower)
      }catch (e) {
        console.log(row.name, row.sku)
      }
      // Return true if any of the conditions match
    })

    const rowsWithQuantity = [...filteredRows]?.map((row) => {
      const match = [...itemsProcessing]?.find((item) => item.sku === row.sku);
      return {
        ...row,
        totalQuantity: match ? match.totalQuantity : 0,
      };
    });
    const activeLetterRows = activeLetter == null ? [...rowsWithQuantity] : [...rowsWithQuantity].filter((row) => 
      (normalizeToEnglish(row?.name?.slice(0, 1)))?.toLowerCase() == activeLetter?.toLowerCase()
    )


    const sortedRows = [...activeLetterRows]
    ?.filter((row) => {
      // console.log('filter place: '+filters.place);
      if (filters.place === 'All') return true
      try {
        return row.place?.includes(filters.place)
      }catch (e) {
        console.log(row.name, row.sku)
      }
    })
    ?.filter((row) => {
      // console.log('filter stand: '+filters.stand);
      if (filters.stand === 'All') return true
      try {
        return row.stand?.includes(filters.stand)
      }catch (e) {
        console.log(row.name, row.sku)
      }
      // Return true if any of the conditions match
    })
    ?.filter((row) => {
      // console.log('filter shelf: '+filters.shelf);
      if (filters.shelf === 'All') return true
      try {
        return row.shelf?.includes(filters.shelf)
      }catch (e) {
        console.log(row.name, row.sku)
      }
      // Return true if any of the conditions match
    })
    ?.filter((row) => {
      // console.log('filter shelf: '+filters.shelf);
      if (filters.stock == 'All') {return true}
      if (filters.stock == 'Yes') {
        if (row.stock && row.updatedBy && row.updatedAt) {
          return true
        } else {
          return false
        }
      } else {
          if (row.stock && row.updatedBy && row.updatedAt) {
          return false
        } else {
          return true
        }
      }
      // Return true if any of the conditions match
    })
    .filter((row) => {
      if (isFilterLessZeroStock) {
        return row.stock < 0
      } 
      return true
    })
    .filter((row) => {
      if (isFilterLessZeroProcessing) {
        return row.totalQuantity < 0
      } 
      return true
    })
    .sort((a, b) => {
      if (order === 'asc') {
        return a[orderBy] < b[orderBy] ? -1 : 1
      }
      return a[orderBy] > b[orderBy] ? -1 : 1
    }).sort((a, b) => {
      return b.stock - a.stock
    }).sort((a, b) => {
      return a.totalQuantity - b.totalQuantity
    })?.sort((a, b) => {
        if (categorySortDerection.name) {
          if (categorySortDerection.name === 'updatedAt') {
            if (parseDate(a[categorySortDerection.name]) < parseDate(b[categorySortDerection.name])) {
              return categorySortDerection.value
            }
            if (parseDate(a[categorySortDerection.name]) > parseDate(b[categorySortDerection.name])) {
              return -categorySortDerection.value
            }
            return 0
          } else if (categorySortDerection.name === 'stock') {
            if (parseFloat(a.stock) > parseFloat(b.stock)) {
              return categorySortDerection.value
            }
            if (parseFloat(a.stock) < parseFloat(b.stock)) {
              return -categorySortDerection.value
            }
            return 0
          } else if (categorySortDerection.name === 'cogs') {
            if (a.ourPrice > b.ourPrice) {
              return categorySortDerection.value
            }
            if (a.ourPrice < b.ourPrice) {
              return -categorySortDerection.value
            }
            return 0
          } else if (categorySortDerection.name === 'totalQuantity') {
            if (parseFloat(a.totalQuantity) > parseFloat(b.totalQuantity)) {
              return categorySortDerection.value
            }
            if (parseFloat(a.totalQuantity) < parseFloat(b.totalQuantity)) {
              return -categorySortDerection.value
            }
            return 0
          } else if (categorySortDerection.name === 'price') {
            if (a.marketPriceCP > b.marketPriceCP) {
              return categorySortDerection.value
            }
            if (a.marketPriceCP < b.marketPriceCP) {
              return -categorySortDerection.value
            }
            return 0
          } else if (categorySortDerection.name === 'place') {
            if (a[categorySortDerection.name] > b[categorySortDerection.name]) {
              return categorySortDerection.value
            }
            if (a[categorySortDerection.name] < b[categorySortDerection.name]) {
              return -categorySortDerection.value
            }
            return 0
          } else if (categorySortDerection.name === 'stand') {
            if (a[categorySortDerection.name] > b[categorySortDerection.name]) {
              return categorySortDerection.value
            }
            if (a[categorySortDerection.name] < b[categorySortDerection.name]) {
              return -categorySortDerection.value
            }
            return 0
          } else if (categorySortDerection.name === 'shelf') {
            if (a[categorySortDerection.name] > b[categorySortDerection.name]) {
              return categorySortDerection.value
            }
            if (a[categorySortDerection.name] < b[categorySortDerection.name]) {
              return -categorySortDerection.value
            }
            return 0
          } else if (categorySortDerection.name === 'name') {
            if (a[categorySortDerection.name.toLowerCase()] > b[categorySortDerection.name.toLowerCase()]) {
              return categorySortDerection.value
            }
            if (a[categorySortDerection.name.toLowerCase()] < b[categorySortDerection.name.toLowerCase()]) {
              return -categorySortDerection.value
            }
            return 0
          }
        } else {
          return 0
        }
      })
    
    setFilteredRowsLength(sortedRows.length)
    setPaginatedRowsValues(sortedRows)
    console.log(sortedRows);
    setPaginatedRows(sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    )
  }, [rows, filters, search, page, rowsPerPage, itemsProcessing, categorySortDerection, isFilterLessZeroStock, isFilterLessZeroProcessing, activeLetter])

  //lock
  const [password, setPassword] = useState('')
  const [openLock, setOpenLock] = useState(false)
  const [show, setShow] = useState(false)
  const navigate = useNavigate()

  const handleShow = () => {
    if (password === '777') {
      setShow(!show)
      setOpenLock(!openLock)
      localStorage.setItem('productManagerAccess', true)
    } else {
      alert('Wrong password')
    }
  }
  useEffect(() => {
    const pass = localStorage.getItem('productManagerAccess') || null
    console.log(pass);
    if (pass) {
      setShow(true)
      setOpenLock(false)
    }
  }, [])

  const mobileView = useMediaQuery('(max-width: 798px)')

  const isAnyPlaces = (store, stand, shelf) => {
    return {
      is: store?.toString()?.split('/').length > 1 || stand?.toString()?.split('/').length > 1 || shelf?.toString()?.split('/').length > 1,
      count: store?.toString()?.split('/').length > 1 ? store?.toString()?.split('/').length : stand?.toString()?.split('/').length > 1 ? stand?.toString()?.split('/').length : shelf?.toString()?.split('/').length > 1 ? shelf?.toString()?.split('/').length : 0,
    }
  }

  const removeArrayElement = (currentString, index) => {
    if (typeof currentString !== 'string') return currentString;
    // Разделяем строку на массив и фильтруем пустые элементы
    const parts = currentString.split('/').filter(part => part !== '');
    // Проверка валидности индекса
    if (index < 0 || index >= parts.length) return currentString;
    // Удаляем элемент и соединяем обратно
    const newParts = [...parts.slice(0, index), ...parts.slice(index + 1)];
    console.log(newParts);
    return newParts.join('/');
  };

  
  

  return isLoading ? (
    <CircularProgress />
  ) : (
    <Box>
      <Modal open={openLock} onClose={() => setOpenLock(false)} aria-labelledby='modal-modal-title' aria-describedby='modal-modal-description'>
        <Box
          sx={{
            position: 'absolute',
            top: '25%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
          }}
        >
          <TextField id='outlined-basic' label='Password' variant='outlined' onChange={(e) => setPassword(e.target.value)} value={password} />
          <Button variant='contained' color='success' onClick={handleShow}>
            Show
          </Button>
        </Box>
      </Modal>
      {!show && (
        <Modal open={!show}>
          <Box>
            <img
              height={200}
              width={200}
              src={lock}
              alt='lock'
              style={{
                cursor: 'pointer',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                filter: 'none',
                zIndex: 9999,
              }}
              onClick={() => setOpenLock(!openLock)}
            />
            <Button
              variant='contained'
              color='success'
              sx={{
                cursor: 'pointer',
                width: '300px',
                height: '50px',
                position: 'absolute',
                top: '5%',
                left: '50%',
                fontSize: '20px',
                transform: 'translate(-50%, -50%)',
              }}
              onClick={() => navigate('/')}
            >
              Return
            </Button>
          </Box>
        </Modal>
      )}
      <Box sx={{display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between', padding: '10px', width: '98vw', flexWrap: 'wrap', boxSizing: 'border-box'}}>
        <ProductManagerFilter rows={paginatedRowsValues} setFilters={setFilters} filters={filters} setSearch={setSearch}/>
        <Box>
          <TextField
            id='outlined-basic'
            label='Search'
            size='small'
            variant='outlined'
            sx={{
              m: 0,
              p: 0,
              width: '300px',
              backgroundColor: 'white',
              borderRadius: '10px',
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#176318',
                  boxShadow: '0px 4px 4px 0px rgba(23, 99, 24, 0.25)',
                },
              }
            }}
            onChange={handleSearchChange} // Only change search state
            value={search} // Keep the value in sync with state
          />
          <AddToStockModal />
          <AddToStockHistoryModal />
        </Box>
      </Box>
      <TableContainer sx={{ filter: show ? 'none' : 'blur(5px)' }} component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label='customized table'>
          <TableHead>
            <TableRow>
              <StyledTableCell />
              <StyledTableCell sx={{ display: 'flex', alignItems: 'center', gap: '10px' }} onClick={(e) => handleSort('name')}>
                {categorySortDerection !== null && categorySortDerection.name !== null && 'name' !== null
                  ? 'Name' +
                    (categorySortDerection.name === 'name' && categorySortDerection.value === 1
                      ? ' ▲'
                      : categorySortDerection.name === 'name' && categorySortDerection.value === -1
                      ? ' ▼'
                      : '')
                  : ''}
              </StyledTableCell>
              {!mobileView && <>
                <StyledTableCell onClick={(e) => handleSort('price')}>
                  {categorySortDerection !== null && categorySortDerection.name !== null && 'price' !== null
                  ? 'Price' +
                    (categorySortDerection.name === 'price' && categorySortDerection.value === 1
                      ? ' ▲'
                      : categorySortDerection.name === 'price' && categorySortDerection.value === -1
                      ? ' ▼'
                      : '')
                  : ''}
                </StyledTableCell>
                <StyledTableCell onClick={(e) => handleSort('cogs')}>
                  {categorySortDerection !== null && categorySortDerection.name !== null && 'cogs' !== null
                  ? 'COGS' +
                    (categorySortDerection.name === 'cogs' && categorySortDerection.value === 1
                      ? ' ▲'
                      : categorySortDerection.name === 'cogs' && categorySortDerection.value === -1
                      ? ' ▼'
                      : '')
                  : ''}
                </StyledTableCell>
                <StyledTableCell onClick={(e) => handleSort('totalQuantity')}>
                  {categorySortDerection !== null && categorySortDerection.name !== null && 'totalQuantity' !== null
                  ? 'Processing' +
                    (categorySortDerection.name === 'totalQuantity' && categorySortDerection.value === 1
                      ? ' ▲'
                      : categorySortDerection.name === 'totalQuantity' && categorySortDerection.value === -1
                      ? ' ▼'
                      : '')
                  : ''}
                  <Checkbox checked={!isFilterLessZeroProcessing} onClick={(e) => {
                  e.stopPropagation()
                  setIsFilterLessZeroProcessing(!isFilterLessZeroProcessing)
                }} />
                </StyledTableCell>
              </>}
              <StyledTableCell onClick={(e) => handleSort('stock')}>
                {categorySortDerection !== null && categorySortDerection.name !== null && 'stock' !== null
                ? 'Stock' +
                  (categorySortDerection.name === 'stock' && categorySortDerection.value === 1
                    ? ' ▲'
                    : categorySortDerection.name === 'stock' && categorySortDerection.value === -1
                    ? ' ▼'
                    : '')
                : ''}
                <Checkbox checked={!isFilterLessZeroStock} onClick={(e) => {
                  e.stopPropagation()
                  setIsFilterLessZeroStock(!isFilterLessZeroStock)
                }} />
              </StyledTableCell>
              {/* <StyledTableCell>Reserve</StyledTableCell> */}
              {!mobileView && <>
                <StyledTableCell onClick={(e) => handleSort('place')}>
                  {categorySortDerection !== null && categorySortDerection.name !== null && 'place' !== null
                  ? 'Storage' +
                    (categorySortDerection.name === 'place' && categorySortDerection.value === 1
                      ? ' ▲'
                      : categorySortDerection.name === 'place' && categorySortDerection.value === -1
                      ? ' ▼'
                      : '')
                  : ''}
                </StyledTableCell>
                <StyledTableCell onClick={(e) => handleSort('stand')}>
                  {categorySortDerection !== null && categorySortDerection.name !== null && 'stand' !== null
                  ? 'Stand' +
                    (categorySortDerection.name === 'stand' && categorySortDerection.value === 1
                      ? ' ▲'
                      : categorySortDerection.name === 'stand' && categorySortDerection.value === -1
                      ? ' ▼'
                      : '')
                  : ''}
                </StyledTableCell>
                <StyledTableCell onClick={(e) => handleSort('shelf')}>
                  {categorySortDerection !== null && categorySortDerection.name !== null && 'shelf' !== null
                  ? 'Shelf' +
                    (categorySortDerection.name === 'shelf' && categorySortDerection.value === 1
                      ? ' ▲'
                      : categorySortDerection.name === 'shelf' && categorySortDerection.value === -1
                      ? ' ▼'
                      : '')
                  : ''}
                </StyledTableCell>
              </>}
                <StyledTableCell onClick={(e) => handleSort('updatedAt')}>
                  {categorySortDerection !== null && categorySortDerection.name !== null && 'updatedAt' !== null
                  ? 'Updated' +
                    (categorySortDerection.name === 'updatedAt' && categorySortDerection.value === 1
                      ? ' ▲'
                      : categorySortDerection.name === 'updatedAt' && categorySortDerection.value === -1
                      ? ' ▼'
                      : '')
                  : ''}
                </StyledTableCell>
                <StyledTableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((row, index) => (
              mobileView ?
              <ProductManagerTableMobileRow
                key={index}
                row={row}
                open={openRows[row.sku] || false}
                toggleRowOpen={toggleRowOpen}
                saveSpoPrice={saveSpoPrice}
                stateSetters={stateSetters}
                stateFields={stateFields}
                handleChange={handleChange}
                inputRefs={inputRefs}
                refetch={refetchAll}
                filters={filters}
                setFilters={setFilters}
                isAnyPlaces={isAnyPlaces}
                removeArrayElement={removeArrayElement}
                itemsProcessing={itemsProcessing}
              />
              :<ProductManagerTableRow
                key={row.sku+index}
                row={row}
                open={openRows[row.sku] || false}
                toggleRowOpen={toggleRowOpen}
                saveSpoPrice={saveSpoPrice}
                stateSetters={stateSetters}
                stateFields={stateFields}
                handleChange={handleChange}
                inputRefs={inputRefs}
                refetch={refetchAll}
                filters={filters}
                setFilters={setFilters}
                isAnyPlaces={isAnyPlaces}
                removeArrayElement={removeArrayElement}
                itemsProcessing={itemsProcessing}
              />
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={filteredRowsLength}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPageOptions={[50, 75, 100]}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      <Box sx={{ 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          background: '#ffffffe0',
          borderRadius: '6px',
          // filter: 'drop-shadow(0px, 0px, 3px #00000057)',
        }}>
        <CustomPagination
          count={data.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
        />
      </Box>
      <AlphaSortBar 
        lettersArray={letters}
        activeLetter={activeLetter}
        setActiveLetter={setActiveLetter}
        directionLeftBar={true}
      />
    </Box>
  )
}

const CustomPagination = ({ count, page, rowsPerPage, onPageChange }) => {
  const handleBackButtonClick = (e) => {
    onPageChange(e, page - 1);
  };

  const handleNextButtonClick = (e) => {
    onPageChange(e, page + 1);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {'<'}
      </IconButton>

      <span style={{ fontSize: '12px'}}>
        Page {page + 1} of {Math.ceil(count / rowsPerPage)}
      </span>

      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {'>'}
      </IconButton>
    </div>
  );
};